import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  IconButton,
  TableSortLabel,
  TableContainer,
  Box,
} from '@material-ui/core';
import AttachmentIcon from '@material-ui/icons/Attachment';
import CommentIcon from '@material-ui/icons/Comment';
import UndoIcon from '@material-ui/icons/Undo';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import { useStyles, StyledTableCell } from '../../adminStyles';

const MainTable = props => {
  const {
    tableRoot,
    tableContainer,
    icons,
    disabledIcons,
    approveBtn,
    negativeBtn,
    sortLabel,
    tableHeaders,
    customHeaderCont,
  } = useStyles();

  const {
    columns,
    popoverOpen,
    handleDetailOpen,
    handleCommentOpen,
    handleAttachmentOpen,
    handleApprove,
    rows,
    sortArray,
    orderAscending,
    orderBy,
    asc,
    searchTerm,
    handleEditOpen,
    user,
    handleAuditOpen
  } = props;

  const renderStyledTableCell = () =>
    columns.map(column =>
      column.id === 'name' || column.id === 'totalHrs' || column.id === 'date' ? (
        <StyledTableCell
          key={column.id}
          align='center'
          padding={column.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === column.id ? orderAscending : false}
        >
          <TableSortLabel
            active={orderBy === column.id}
            key={column.id}
            direction={asc}
            onClick={sortArray(rows, column.id)}
            className={sortLabel}
          >
            {column.label}
          </TableSortLabel>
        </StyledTableCell>
      ): (
        <StyledTableCell
          key={column.id}
          align='center'
          padding={column.disablePadding ? 'none' : 'default'}
        >
          {(column.id=='edit' &&user.role=="clientManager")?"":column.label}
        </StyledTableCell>
      )
    );

  const renderTableBody = () =>
    rows
      .filter(row => row.name.toLowerCase().includes(searchTerm.toLowerCase()))
      .map((row, i) => {
        const adminComments = row.comments || '';
        return (
          <TableRow hover role='checkbox' tabIndex={-1} key={row.code}>
            {columns.map(column => {
              const value = row[column.id]||"";

              return (
                <TableCell key={column.id} align={'center'}>
                  {column.id === 'name' ? value : null}
                  {column.id === 'date' ? value : null}
                  {column.id === 'totalHrs' ? value : null}
                  {column.id === 'attachments' ? (
                    <IconButton
                      onClick={() => handleAttachmentOpen(row)}
                      disabled={!row.attachments.length}
                    >
                      <AttachmentIcon
                        className={row.attachments.length ? icons : disabledIcons}
                      />
                    </IconButton>
                  ) : null}
                  
                  {column.id === 'comments' ? (
                    <div>
                      <IconButton
                        aria-owns={popoverOpen ? 'mouse-over-popover' : undefined}
                        aria-haspopup='true'
                        onClick={() => handleCommentOpen(row)}
                        disabled={adminComments.length <= 0 ? true : false}
                      >
                        <CommentIcon
                          className={adminComments.length > 0 ? icons : disabledIcons}
                          alt='View Comments'
                        />
                      </IconButton>
                    </div>
                  ) : null}
                  {column.id === 'details' ? (
                    <IconButton
                      onClick={() => handleDetailOpen(row)}
                      disabled={!row.details.length}
                    >
                      <PlaylistAddIcon
                        className={row.details.length ? icons : disabledIcons}
                      />
                    </IconButton>
                  ) : null}
                   {column.id === 'Action' ? (
                    <IconButton
                      onClick={() => handleAuditOpen(row)}
                      disabled={!row.details.length}
                    >
                      <PlaylistAddIcon
                        className={row.details.length ? icons : disabledIcons}
                      />
                    </IconButton>
                  ) : null}
                  {(column.id  === 'edit' && user&&user.role !="clientManager") ? (
                    <Button onClick={() => handleEditOpen(row)} className={negativeBtn}> 
                      Edit
                    </Button>
                  ) : null}
                  {column.id === 'approval' ? (
                    row.status === 'APPROVAL_PENDING' ? (
                      <Button
                        className={approveBtn}
                        onClick={() => handleApprove(row)}
                        disabled={row.status === 'APPROVED'}
                        variant='contained'
                        color='primary'
                      >
                        Approve
                      </Button>
                    ) : (row.status === 'SUBMIT_PENDING'||row.status === 'PENDING') ? (
                      <div
                        style={{
                          color: 'blue',
                          fontWeight: 'bold',
                        }}
                      >
                        PENDING
                      </div>
                    ) : (
                      <Box display='flex'>
                        <Box m={1}>
                          <span
                            style={{
                              color: 'green',
                              fontWeight: 'bold',
                            }}
                          >
                            APPROVED
                          </span>
                        </Box>
                        <Box m={1}>
                          <IconButton
                            aria-label='Undo Approved'
                            size='small'
                            onClick={() => handleApprove(row)}
                          >
                            <UndoIcon className={icons} fontSize='small' />
                          </IconButton>
                        </Box>
                      </Box>
                    )
                  ) : null}
                </TableCell>
              );
            })}
          </TableRow>
        );
      });

  const renderTableHeaders = () => {
    return (
      <div className={customHeaderCont}>
        <div align='center' className={tableHeaders}>
          Pending:
          <span style={{ color: '#42ADE2' }}>
            {
              rows
                .filter(row => row.name.toLowerCase().includes(searchTerm.toLowerCase()))
                .filter(function (obj) {
                  return (obj.status === 'SUBMIT_PENDING' ||obj.status==='PENDING');
                }).length
            }
          </span>
        </div>
        <div align='center' className={tableHeaders}>
          Submitted:
          <span style={{ color: '#42ADE2' }}>
            {
              rows
                .filter(row => row.name.toLowerCase().includes(searchTerm.toLowerCase()))
                .filter(function (obj) {
                  return obj.status === 'APPROVAL_PENDING';
                }).length
            }
          </span>
        </div>
        <div align='center' className={tableHeaders}>
          Approved:
          <span style={{ color: '#42ADE2' }}>
            {
              rows
                .filter(row => row.name.toLowerCase().includes(searchTerm.toLowerCase()))
                .filter(function (obj) {
                  return (
                    obj.status !== 'APPROVAL_PENDING' && obj.status !== 'SUBMIT_PENDING' && obj.status !== 'PENDING'
                  );
                }).length
            }
          </span>
        </div>
      </div>
    );
  };
  return (
    <Paper className={tableRoot}>
      <TableContainer className={tableContainer}>
        <TableRow>{renderTableHeaders()}</TableRow>
        <Table stickyHeader>
          <TableHead>
            <TableRow>{renderStyledTableCell()}</TableRow>
          </TableHead>
          <TableBody>{renderTableBody()}</TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default MainTable;
